var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 125,
    viewBox: "0 0 300 125",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186 93.1H84c-1.1 0-2-.9-2-2v-74c0-1.1.9-2 2-2h102c1.1 0 2 .9 2 2v74c0 1.1-.9 2-2 2z",
    fill: "#fff",
    filter: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 23.1H90v40h90v-40z",
    fill: "#E8E9EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.7 35.8l7.3 7.3v16h-44l15.3-15.3c.5-.5 1.1-.7 1.7-.7.6 0 1.3.3 1.7.7l3.3 3.3 11.3-11.3c.5-.5 1.1-.7 1.7-.7.6 0 1.3.2 1.7.7z",
    fill: "#7FBEC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.8 41.3l-6.8 6.8c-4.5 4.5-10.6 7-17 7h-16.2c-3.7 0-7.3-1.5-9.9-4.1l-3.2-3.2c-3-3-7.1-4.7-11.3-4.7H90v20h90v-30h-2.4c-7.4 0-14.5 2.9-19.8 8.2z",
    fill: "#108060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180 63.1H90v14h90v-14z",
    fill: "#7FBEC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.8 73.3l-6.8-3.2c-4.5-2.1-10.6-3-17-3h-16.2c-3.7 0-7.3.4-9.9 1.6l-3.2 1.5c-3 1.4-7.1 2.9-11.3 2.9H90v-10h90v14h-2.4c-7.4 0-14.5-1.4-19.8-3.8z",
    fill: "#5BA7B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126 69.1l-7.7-25c-.2-.6-.7-1-1.3-1-.6 0-1.1.4-1.3 1l-7.7 25h3l-3 8h18l-3-8h3z",
    fill: "#02614E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216 111.1h-4v-44h4c1.1 0 2 .9 2 2v40c0 1.1-.9 2-2 2zm-28-44h8v-2c0-1.1-.9-2-2-2h-6v4z",
    fill: "#828A91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M212 111.1h-60c-1.1 0-2-.9-2-2v-8h64v8c0 1.1-.9 2-2 2zm-20-44v-2c0-1.1-.9-2-2-2h-38c-1.1 0-2 .9-2 2v12h64v-8c0-1.1-.9-2-2-2h-20z",
    fill: "#D2D5D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214 77.1h-64v24h64v-24z",
    fill: "#DE6A5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162 67.1h-8v6h8v-6z",
    fill: "#42474C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172 67.1h-6v4h6v-4z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M208 63.1h-6c-1.1 0-2 .9-2 2v2h10v-2c0-1.1-.9-2-2-2zm-26 42c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16z",
    fill: "#42474C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182 101.1c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218 77.1h-4v24h4v-24z",
    fill: "#AF5947"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 72,
    y: 7.1,
    width: 126,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.da668982bf1026a8cce1bd9edb211cc3.svg";
export { ForwardRef as ReactComponent };